import React from "react";
import "./styles/About.css";
import NawiFoto from "../assets/Nawi-Foto.png";
import { useState } from "react";
import BelMailOns from "./compUse/BelMailOns";

//over ons Section
function About() {
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({
    title: "",
    email: "",
    phone: "+31 6 14 96 45 00",
  });

  const CORRECT_PHONE = "+31 6 14 96 45 00";
  const handleButtonClick = (type) => {
    const content = {
      title: type === "bel" ? "Bel ons" : "Mail ons",
      email: "info@gridarea.nl",
      phone: CORRECT_PHONE,
    };
    setModalContent(content);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };
  return (
    <div className="aboutContainer">
      <div className="aboutContent">
        <h1 className="overonsTitle">Slim, Fris, Modern.</h1>

        <div
          className="AboutSection" 
          // style={{
          //   display: "flex",
          //   flexDirection: "row",
          //   gap: "20px",
          //   height: "auto",
          //   paddingTop: "20px",
          // }}
        >
          <div className="overonsTextContainerHalve">
            <div className="TextBox">
              <h2 className="TextBoxTitle">
                Waarom bedrijven voor ons kiezen?
              </h2>
              <p style={{ color: "white", paddingRight: "5px" }}>
               We leveren snel en betrouwbaar maatwerk, met persoonlijk contact en altijd focus op jouw resultaat.
              </p>
            </div>
            <div className="TextBox">
              <h2 className="TextBoxTitle">Wat voor apps maken wij?</h2>
              <p style={{ color: "white", paddingRight: "5px"  }}>
                Van mobiele apps tot dashboards, platforms en API-koppelingen: wij bouwen alles wat jouw digitale processen versterkt.
              </p>
            </div>
            <div className="TextBox">
              <h2 className="TextBoxTitle">Hoe werken wij samen?</h2>
              <p style={{ color: "white", paddingRight: "5px"  }}>
                
We vertalen jouw ideeën naar een schaalbaar product met een helder, flexibel en transparant proces.
Jij kent je doelgroep, wij vertalen dat naar techniek. Van ontwerp tot oplevering, je weet altijd waar we zijn.


              </p>
            </div>
          </div>

          <div className="overonsTextContainerHalve2">
            <div className="contactonsGridContent">
              <div className="overonsGridHeader">
                Nawaaz <br /> Head business development
              </div>

              <div className="avatar">
                <img className="avatarImg" src={NawiFoto} alt="fotovanNawaaz" />
              </div>
              <div className="contentText">
                <h3 className="meerwetenText">Meer weten?</h3>
                <p>Neem contact met ons op.</p>
              </div>

              <div className="buttonContent">
                <button
                  className="contactButton"
                  onClick={() => handleButtonClick("bel")}
                >
                  Contact
                </button>
                <BelMailOns
                  show={showModal}
                  onClose={closeModal}
                  title={modalContent.title}
                  email={modalContent.email}
                  phone={modalContent.phone}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;


